<template>
  <div id="rStudioHeader">
    <LicenseMessage />
    <div class="band">
      <div class="innards bandContent">
        <div id="leftSideContainer">
          <div
            v-if="showTitle"
            id="menuToggler"
            :class="{ asNeeded : navTogglerAsNeeded }"
            @click="handleNavToggleClick($event)"
          />
        </div>
        <div
          id="logoContainer"
          data-automation="top-logo"
        >
          <router-link
            v-if="!showTitle"
            :to="{ name: 'home' }"
            class="productLogo hideAsNeeded"
          />
          <div
            id="headerTitle"
            :style="{ cursor: pinNavPanel ? 'auto' : 'pointer' }"
            @click="handleNavToggleClick($event)"
          >
            {{ headerTitle }}
          </div>
        </div>
        <div class="menu main">
          <span class="menuItems">
            <router-link
              v-for="menuItem in menuItems"
              :key="menuItem.routeName"
              :to="{ name: menuItem.routeName, params: menuItem.routeParams }"
              class="menuItem"
              :data-automation="`menu-${menuItem.routeName}`"
            >
              {{ menuItem.label }}<span
                v-if="menuItem.labelExtra"
                v-html="menuItem.labelExtra"
              />
            </router-link>
          </span>
        </div>
        <div
          id="rightSideContainer"
          class="flex"
        >
          <div
            v-if="showBiocVersion"
            class="showBiocContainer"
          >
            <div
              style="font-size: 10px; color: #888; margin-bottom: 3px; text-transform: uppercase;"
              data-automation="top-bioc-version-label"
            >
              Bioconductor
            </div>
            <div style="font-size: 12px;">
              <a
                href=""
                data-automation="top-bioc-version-change"
                @click.prevent="handleChangeBiocVersion"
              >{{ biocVersionDisplay(selectedBiocVersion) }}</a>
            </div>
          </div>
          <div v-if="showOS">
            <div
              style="font-size: 10px; color: #888; margin-bottom: 3px; text-transform: uppercase;"
              data-automation="top-clientos-label"
            >
              Client OS
            </div>
            <div style="font-size: 12px;">
              <a
                href=""
                data-automation="top-clientos-change"
                @click.prevent="handleChangeOS"
              >{{ selectedOS.display }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <StatusMessage />
    <Alerts />

    <ChangeOSDialog
      v-if="showChangeOSDialog"
      @closeDialog="closeChangeOSDialogDialog"
    />
    <ChangeBiocVersionDialog
      v-if="showChangeBiocVersionDialog"
      @closeDialog="closeChangeBiocVersionDialogDialog"
    />
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import * as types from '../store/mutation-types'
import StatusMessage from './StatusMessage'
import LicenseMessage from './LicenseMessage'
import Alerts from './Alerts'
import * as messageTypes from '../constants/message-types'
import ChangeOSDialog from './dialogs/ChangeOSDialog'
import ChangeBiocVersionDialog from './dialogs/ChangeBiocVersionDialog'
import { REPO_TYPE_BIOCONDUCTOR, REPO_TYPE_R } from '../constants/repo-types'

export default {
  name: 'StandardHeader',
  components: {
    Alerts,
    LicenseMessage,
    StatusMessage,
    ChangeOSDialog,
    ChangeBiocVersionDialog,
  },
  data: function () {
    return {
      showChangeOSDialog: false,
      showChangeBiocVersionDialog: false,
    }
  },
  computed: {
    ...mapState({
      menuItems: state => state.appFrame.menuItems,
      navTogglerAsNeeded: state => state.appFrame.navTogglerAsNeeded,
      headerTitle: state => state.appFrame.headerTitle,
      showTitle: state => state.appFrame.headerTitle.length > 0,
      violation: state => state.licensing.violation,
      selectedOS: state => state.packages.selectedOS,
      selectedBiocVersion: state => state.packages.selectedBiocVersion,
      currentRepoType: state => state.repos.currentRepoType,
      biocVersions: state => state.status.biocVersions,
      pinNavPanel: state => state.appFrame.pinNavPanel,
    }),
    ...mapGetters(['getWindow']),
    showOS: function () {
      return this.menuItems.length && (this.currentRepoType === REPO_TYPE_R || this.currentRepoType === REPO_TYPE_BIOCONDUCTOR)
    },
    showBiocVersion: function () {
      if (!this.biocVersions || this.biocVersions.length === 0) {
        return false
      }
      return this.menuItems.length && this.currentRepoType === REPO_TYPE_BIOCONDUCTOR
    },
  },
  watch: {
    violation: function (value) {
      if (value) {
        const message = 'The number of repos exceeds the licensed repo count. Please see a system administrator.'
        this.setLicenseMessage({ message: { message, type: messageTypes.LICENSE_MESSAGE } })
      } else {
        this.setLicenseMessage({ message: null })
      }
    },
  },
  created: function () {
    this.getLicenseStatus()
  },
  mounted: function () {
    // Refresh the license info every 30 seconds
    this.timerId = this.getWindow.setInterval(this.getLicenseStatus, 30000)
  },
  beforeDestroy: function () {
    if (this.timerId) {
      this.getWindow.clearInterval(this.timerId)
    }
  },
  methods: {
    ...mapActions([
      'getLicenseStatus',
      'setLicenseMessage',
    ]),
    biocVersionDisplay: function (biocVersion) {
      const rVersion = biocVersion.r_version ? ` (R ${biocVersion.r_version})` : ''
      return `${biocVersion.bioc_version}` + rVersion
    },
    handleNavToggleClick: function ($event) {
      if ($event.target.id === 'headerTitle' && this.pinNavPanel) {
        return
      }
      this.$store.commit(types.SET_SHOW_NAV_PANEL, true)
    },
    handleChangeOS: function () {
      this.showChangeOSDialog = true
    },
    handleChangeBiocVersion: function () {
      this.showChangeBiocVersionDialog = true
    },
    closeChangeOSDialogDialog: function () {
      this.showChangeOSDialog = false
    },
    closeChangeBiocVersionDialogDialog: function () {
      this.showChangeBiocVersionDialog = false
    },
  },
}
</script>

<style scoped="scoped">
  .showBiocContainer {
    margin-right: 2em;
  }
</style>
